import React, { type ReactNode } from 'react'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { type SxProps, type Theme } from '@mui/material/styles'

interface IconButtonWithTooltipProps {
  label: string
  color?: 'default' | 'inherit' | 'primary' | 'secondary'
  onClick?: () => void
  disabled?: boolean
  icon: ReactNode
  placement?: 'bottom' | 'top' | 'right' | 'left'
  sx?: SxProps<Theme>
}

export const IconButtonWithTooltip: React.FC<IconButtonWithTooltipProps> = ({
  label,
  color,
  onClick = () => {},
  disabled = false,
  icon,
  placement = 'bottom',
  sx
}) => {
  return (
    <Tooltip title={label} placement={placement}>
      <span>
        <IconButton
          aria-label={label}
          onClick={(e) => {
            e.stopPropagation()
            onClick()
          }}
          disabled={disabled}
          {...((sx != null) ? { sx } : { color })}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  )
}
